import dateFormat from 'dateformat';

export default {

    dayStr: [
        'อาทิตย์',
        'จันทร์',
        'อังคาร',
        'พุธ',
        'พฤหัสบดี',
        'ศุกร์',
        'เสาร์',
    ],
    monthStr: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฏาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
    ],

    getLastDateOfMonth(date) {
        date = new Date(date);
        date.setMonth(date.getMonth() + 1);
        date.setDate(0);
        return date.getDate();
    },

    compareDate(date1, date2) {
        date1 = new Date(date1);
        date2 = new Date(date2);
        if (date1.getFullYear() < date2.getFullYear()) {
            return -1;
        } else if (date1.getFullYear() > date2.getFullYear()) {
            return 1;
        } else if (date1.getMonth() < date2.getMonth()) {
            return -1;
        } else if (date1.getMonth() > date2.getMonth()) {
            return 1;
        } else if (date1.getDate() < date2.getDate()) {
            return -1;
        } else if (date1.getDate() > date2.getDate()) {
            return 1;
        }
        return 0;
    },

    numberToDayString(arr) {
        return arr.map(i => this.dayStr[i]);
    },

    numberToMonthString(arr) {
        return arr.map(i => this.monthStr[i - 1]);
    },

    timestampToDate(timestamp) {
        if (timestamp === '') return '';
        const date = new Date(parseInt(timestamp, 10));
        return `${dateFormat(date, 'd/m/')}${parseInt(dateFormat(date, 'yyyy'), 10) + 543} ${dateFormat(date, 'HH:MM')} น.`;
    },

    timestampToTime(timestamp) {
        if (timestamp === '') return '';
        const date = new Date(parseInt(timestamp, 10));
        return `${dateFormat(date, 'HH:MM')} น.`;
    },

    beauty(sqldate) {
        return sqldate;
    },

    // yyyy-mm-dd
    dateParser(date) {
        if (date instanceof Date) {
            date = `${dateFormat(date, 'yyyy-mm-dd')}`;
        }
        const dayNum = parseInt(date.substr(8, 2), 10);
        const monthNum = parseInt(date.substr(5, 2), 10);
        const yearNum = parseInt(date.substr(0, 4), 10) + 543;
        return {
            day: dayNum,
            month: monthNum,
            year: yearNum,
        };
    },

    dateChristParser(date) {
        if (date instanceof Date) {
            date = `${dateFormat(date, 'yyyy-mm-dd')}`;
        }
        const dayNum = parseInt(date.substr(8, 2), 10);
        const monthNum = parseInt(date.substr(5, 2), 10);
        const yearNum = parseInt(date.substr(0, 4), 10);
        return {
            day: dayNum,
            month: monthNum,
            year: yearNum,
        };
    },

    thaidateFromISO(date) {
        return `${dateFormat(date, 'd/m/')}${parseInt(dateFormat(date, 'yyyy'), 10) + 543} ${dateFormat(date, 'HH:MM')} น.`;
    },

    thaidateNotBeauty(date) {
        if (date === undefined || date === '') return '-';
        const d = this.dateParser(date);
        return `${d.day}/${d.month}/${d.year}`;
    },

    dateNotBeauty(date) {
        if (date === undefined || date === '') return '-';
        const d = this.dateChristParser(date);
        return `${d.day}/${d.month}/${d.year}`;
    },

    thaidate(date) {
        if (date === undefined) return '';
        const d = this.dateParser(date);
        return `${d.day} ${this.monthStr[d.month - 1]} ${d.year}`;
    },

    thaidateNoYear(date) {
        if (date === undefined) return '';
        const d = this.dateParser(date);
        return `${d.day} ${this.monthStr[d.month - 1]}`;
    },

    thaimonth(date) {
        const d = this.dateParser(date);
        return `${this.monthStr[d.month - 1]} ${d.year}`;
    },

    thaiyear(date) {
        const d = this.dateParser(date);
        return `${d.year}`;
    },

};
